<template>
  <v-card flat>
    <v-card-text class="d-flex align-center flex-wrap pb-0">
      <div>
        <span class="d-block text--secondary">Последний статус от Delivery</span>
        <span class="d-block font-weight-medium">{{ lastStatus }}</span>
      </div>
      <v-spacer></v-spacer>
      <v-btn
        outlined
        small
        :loading="loading"
        @click="refresh()"
      >
        <v-icon
          size="18"
          class="me-2"
        >
          {{ icons.mdiRefresh }}
        </v-icon>
        <span>Обновить</span>
      </v-btn>
    </v-card-text>

    <v-card-text>
      <v-alert
        v-if="error"
        type="error"
        dense
        text
        class="mb-0"
      >
        {{ error }}
      </v-alert>

      <v-alert
        v-else-if="loaded && !events.length"
        text
        color="info"
        class="mb-0"
      >
        Статусов пока нет: вебхуки по этому заказу не приходили.
      </v-alert>

      <v-simple-table
        v-else-if="events.length"
        dense
      >
        <thead>
          <tr>
            <th>Время</th>
            <th>Статус</th>
            <th>Курьер</th>
            <th v-if="shown.restaurant">
              Ресторан
            </th>
            <th v-if="shown.queue">
              Номер в очереди
            </th>
            <th v-if="shown.cancellation">
              Кто отменил
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="event in events"
            :key="event.id"
          >
            <td class="text-no-wrap py-2">
              {{ time(event.occurredAt) }}
              <div
                v-if="lateRecord(event)"
                class="text-caption text--secondary"
              >
                записано в {{ lateRecord(event) }}
              </div>
            </td>
            <td>
              <v-chip
                small
                label
                :color="statusColor(event.status)"
                class="v-chip-light-bg"
                :class="`${statusColor(event.status)}--text`"
              >
                {{ event.statusName }}
              </v-chip>
            </td>
            <td>{{ event.courierName || '—' }}</td>
            <td v-if="shown.restaurant">
              {{ event.restaurantName || '—' }}
            </td>
            <td v-if="shown.queue">
              {{ event.qmsId || '—' }}
            </td>
            <td v-if="shown.cancellation">
              {{ event.cancellationSource || '—' }}
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { mdiRefresh } from '@mdi/js'
import { lateRecordTime, orderStatusColor, toCardDateTime } from '@/helpers/orders'

export default {
  name: 'OrderStatusHistory',
  async mounted() {
    await this.refresh()
  },
  data: () => ({
    icons: { mdiRefresh },
  }),
  computed: {
    ...mapState('orderStatusHistory', ['events', 'loading', 'loaded', 'error']),
    lastStatus() {
      const last = this.events[this.events.length - 1]

      if (last) return `${last.statusName} · ${toCardDateTime(last.occurredAt)}`

      return this.loaded ? 'статусов ещё не было' : '—'
    },

    shown() {
      return {
        restaurant: this.events.some(event => event.restaurantName),
        queue: this.events.some(event => event.qmsId),
        cancellation: this.events.some(event => event.cancellationSource),
      }
    },
  },
  methods: {
    ...mapActions('orderStatusHistory', ['fetchHistory']),
    time: toCardDateTime,
    lateRecord: lateRecordTime,
    statusColor: orderStatusColor,
    async refresh() {
      const { id } = this.$route.params
      await this.fetchHistory(id)
    },
  },
}
</script>
